import { render, staticRenderFns } from "./dataviews.vue?vue&type=template&id=5ac930cc&scoped=true"
import script from "./dataviews.vue?vue&type=script&lang=js"
export * from "./dataviews.vue?vue&type=script&lang=js"
import style0 from "./dataviews.vue?vue&type=style&index=0&id=5ac930cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac930cc",
  null
  
)

export default component.exports